import { HttpClient } from '@angular/common/http';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import * as _ from 'lodash';
import { doGetPromise } from '../../../../config/core.httpclient-utils';
import { UserService } from '../../../../services/core.user.service';

@Component({
    selector: 'org-selector',
    template: require('./org.selector.component.html')
})
export class OrgSelectorComponent implements OnInit {
    @Input() org: any;
    // @Input() orgs: any[];
    @Input() disabled: boolean;
    @Output() selectOrg: EventEmitter<any> = new EventEmitter<any>();

    filter: string = '';
    orgs = [];
    filterOrgs: any;

    constructor(
        private httpClient: HttpClient,
        private userService: UserService,
    ) {}

    ngOnInit(): void {
        this.filterOrgs = _.debounce(this.doSearch, 250, { 'maxWait': 1000 });
        this.doSearch();
    }

    setOrg(org: any = false): void {
        if (org?.selected) {
            this.org = false;
        } else {
            this.org = org;
        }
        this.orgs = this.setSelectedOrg(this.orgs, this.org);
        this.selectOrg.emit(this.org);
    }

    private setSelectedOrg(orgs: any[], org: any): any[] {
        return _.map(orgs, (item) => {
            item.selected = (_.get(item, 'id', '') === _.get(org, 'id', ''));
            return item;
        });
    }

    private doSearch(): void {
        const unixName = this.userService.getUnixName();
        const url = `/api/user/${ unixName }/projects`;
        const q = this.filter?.length > 0 ? this.filter : null;
        const params = { isOrg: true, q: q };
        doGetPromise(this.httpClient, url, params)
            .then(ret => {
                this.orgs = this.setSelectedOrg(_.get(ret, 'items', []), this.org);
            }, (response) => {
                console.log('Org search failed', response);
            });
    }
}
